module.exports = __webpack_public_path__ + "static/calendar_preset_save-9353e13497e830ce70fd03a95f8b4ad6.png";